import { render } from "./CoolpadMallMobile.vue?vue&type=template&id=7c257ac4"
import script from "./CoolpadMallMobile.vue?vue&type=script&lang=js"
export * from "./CoolpadMallMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__